// extracted by mini-css-extract-plugin
export var container = "_vl-0";
export var table = "_vl-2";
export var tableWrapper = "_vl-1";